const filenameToMimeType = (filename: string): string => {
  const mimeTypes: Record<string, string> = {
    // Ajoutez ici d'autres types MIME au besoin
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    zip: "application/zip",
  };

  const fileExtension = filename
    .split(".")
    .pop()
    ?.toLowerCase();

  if (fileExtension && mimeTypes[fileExtension]) {
    return mimeTypes[fileExtension];
  } else {
    // Type MIME par défaut si l'extension n'est pas reconnue
    return "application/octet-stream";
  }
};

export default filenameToMimeType;
